import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import {storeLocationIdAction, storePhyIdAction,  storeUserIdPhyIdAction, StorePhysicianUserIdAction, ClearPhysicianUserIdAction, storePrescriberIdAction} from './auth.action'
import { patch } from '@ngxs/store/operators';
import { storeUserIdPhyIdModel } from './storeuseridphyidmodel';

const defaultState = {
    userId:0,
    physicianId:0,
    userName:'',
    locationId:0,
    shortName:'',
    staffId:0,
    practiceId:0,
    roleId:0,
    roleName:'',
    // frompage:'',
    userTypeId:0,
    physicianUserId: 0,
    //nursingStationIds: ''
    serviceLevels:[],
    userTypeName:'',
    prescriberId:0,
    prescriberUserInternalId:0,
    physicianName:'',
    jobTitle:''
 }

 @State<storeUserIdPhyIdModel>({
     name: 'userIdPhyId',
     defaults: defaultState
 })
 @Injectable()
 export class storeUserIdPhyIdState {
 
     constructor( ) {
     }
 
     @Selector()
     static getUserIdPhyId(state: storeUserIdPhyIdModel) {
         return state;
     }
     @Action(storeUserIdPhyIdAction)
     storeUserIdPhyIdAction({getState, patchState}: StateContext<storeUserIdPhyIdModel>, {payload}: storeUserIdPhyIdAction) {
         const state = getState();
         patchState({
              userId:payload.userId,
              physicianId:payload.physicianId,
              userName:payload.userName,
              locationId:payload.locationId,
              shortName:payload.shortName,
              staffId:payload.staffId,
              practiceId:payload.practiceId,
              roleId:payload.roleId,
              roleName:payload.roleName,
              userTypeId:payload.userTypeId,
              physicianUserId: payload.physicianUserId,
             // nursingStationIds: payload.nursingStationIds
             serviceLevels:payload.serviceLevels,
             userTypeName:payload.userTypeName,
             physicianName:payload.physicianName,
             jobTitle:payload.jobTitle
         });
     }
     @Action(storePhyIdAction)
     storePhyIdAction({getState, patchState}: StateContext<storeUserIdPhyIdModel>, {payload}: storePhyIdAction) {

        const state = getState();
        patchState({
     
             physicianId:payload
        });
    }
    @Action(storePrescriberIdAction)
    storePrescriberIdAction({getState, patchState}: StateContext<storeUserIdPhyIdModel>, {payload}: storePrescriberIdAction) {

       const state = getState();
       patchState({
    
            prescriberId:payload.prescriberId,
            prescriberUserInternalId:payload.prescriberUserInternalId

       });
   }
    @Action(storeLocationIdAction)
     storeLocationIdAction({getState, patchState}: StateContext<storeUserIdPhyIdModel>, {payload}: storeLocationIdAction) {

        const state = getState();
        patchState({
     
            locationId:payload
        });
    }
    @Action(StorePhysicianUserIdAction)
    storePhysicianUserIdAction({patchState}: StateContext<storeUserIdPhyIdModel>, {payload}: StorePhysicianUserIdAction) {
        patchState({
            physicianUserId: payload
        })
    }
    @Action(ClearPhysicianUserIdAction)
    clearPhysicianUserIdAction({patchState, setState}: StateContext<storeUserIdPhyIdModel>) {
        // patchState(defaultState);
        setState(patch(defaultState));
    }
//     @Action(storeroutingAction)
//     storeroutingAction({getState, patchState}: StateContext<storeUserIdPhyIdModel>, {payload}: storeroutingAction) {

//        const state = getState();
//        patchState({
    
//            frompage:payload
//        });
//    }
       /* @Action(StoreNursingStationIds)
        storeNursingStationIds({patchState}: StateContext<storeUserIdPhyIdModel>, {payload}: StoreNursingStationIds) {
            patchState({
                nursingStationIds: payload
            })
        }*/

    } 